import { BigNumber } from "shared/cubiq-model-multi-asset";
import { OEGammaLegType } from "../enums/oe-gamma-leg-type";

export class OEPanelGammaLegIdRate {
  public legId: Number;
  public rate: BigNumber;

  public OEPanelGammaLegIdRate(legId: Number, rate: BigNumber) {
    this.legId = legId;
    this.rate = rate;
  }
}

export class NewLegResponse {
  public legType: OEGammaLegType;
  public isTooCloseAbove: boolean;
  public isTooCloseBelow: boolean;
}
